import React from 'react';
import { Form, Stack } from 'react-bootstrap'

function FormSelect(props) {
    return (
        <Form.Group className='m-4'>
            <Form.Label className='d-flex justify-content-center'>{props.title}</Form.Label>
            <Stack direction='horizontal' gap={3} className='d-flex justify-content-center'>
                {['1', '2', '3', '4', '5'].map((value) => (
                    <Form.Check
                        required
                        label={value}
                        name={props.name}
                        type="radio"
                        id={`${props.name}-${value}`}
                        onChange={() => {
                            props.saveHandler(props.name, value);
                        }}
                        defaultChecked={props.defaultValue == value ? true : false}

                    />
                ))}
            </Stack>
        </Form.Group>
    );
}

export { FormSelect }